<template>
  <div class="campaignReport">
    <div class="campaignReport__header">
      <div class="campaignReport__header__title">
        <h1 class="medium-title">Measurement</h1>
      </div>
      <div class="campaignReport__header__menu">
        <ul>
          <router-link tag="li" :to="{ name: 'allcampaign'}">Static Advertising</router-link>
          <!-- <router-link tag="li" :to="{ name: 'bus'}">Digital Advertising</router-link> -->
          <router-link tag="li" :to="{ name: 'busmeasurement'}">Transit Advertising</router-link>
        </ul>
      </div>
    </div>
    <router-view/>
  </div>
</template>

<script>


export default {
  name: 'adx-measurement',
  components: {
    
  },
  props: {

  },
  data() {
    return {

    }
  },
  computed: {

  },
  watch: {

  },
  beforeCreate() {

  },
  created() {

  },
  beforeMount() {

  },
  mounted() {

  },
  beforeUpdate() {

  },
  updated() {

  },
  activated() {

  },
  deactivated() {

  },
  beforeDestroy() {

  },
  destroyed() {

  },
  methods: {

  }
}
</script>

<style lang='scss' scoped>
@import './index.scss';
</style>